/* eslint-disable */

/**
 * on each filter click:
 * - check what filters are selected
 * - add / remove clicked filter
 * - format and send AJAX
 *
 */
let $filters = [];
let $total_products;
let $total_pages;
let $paged = 1;
let self;
let isCallingAjax = false;
let $filtersLocation;
let $productsLocation;
let $btnLoadMore;
let $search_overlay;
let $lastPage = false;
let $hasFilter = false;

export class Shop {

  constructor() {
    self = this;

    // is the Shop element even here?
    if (!$('.shop').length > 0) return;

    $btnLoadMore = $('.btn-load-more');
    $filtersLocation = $('.filters');
    $productsLocation = $('.products-results');
    $search_overlay = $('.search-overlay');

    // Bind filter events
    $filtersLocation.on('click', '.filter_term', e => {
      this.onFilterClick(e)
    });
    $btnLoadMore.on('click', e => {
      this.onLoadClick(e)
    });
    $('.btn_clear_filters').on('click', 'a', e => {
      this.clearFilters()
    });

    this.initShop();

    this.initInfiniteLoad()

  }

  /**
   * Infinite load more: Load if button comes into viewport
   */
  initInfiniteLoad() {
    $(window).on("scroll", function () {
      if (isCallingAjax) return;
      if ($lastPage) return;

      // if button is visible, and in view, trigger a 'load more' action
      if ($('.btn-load-more').is(":visible")
        && self.isInViewport(document.querySelector('.btn-load-more'))) {
        $btnLoadMore.trigger('click');
      }
    });
  }

  // render sessionStorage settings
  // set filters from url
  // set paged from url
  // set load button
  initShop() {

    /**
     * clear filters if url parms are given
     */
    if (location.href.match(/\?./)) {
      this.clearFilters()
    }

    /**
     * Render the previous HTML if any
     */
    if (sessionStorage.getItem('productHtml')) {
      $productsLocation.html(sessionStorage.getItem('productHtml'));
    }

    /**
     * Render the load more button or not
     */
    if (sessionStorage.getItem('$lastPage') === 'true') {
      $btnLoadMore.hide();
    }

    /**
     *  Render sessionStorage of filter checkboxes
     */
    $hasFilter = false;
    let currGroupFilters = JSON.parse(sessionStorage.getItem('groupFilter')) || {};

    Object.entries(currGroupFilters).forEach((group) => {
      const [taxonomy, values] = group;
      Object.entries(values).forEach((value) => {
        const [i, term] = value;

        $hasFilter = true;

        $('[data-slug="' + term + '"]').children('input').prop('checked', true);
      })
    });

    // Show reset button or not?
    $('.btn_clear_filters').toggle($hasFilter);

    /**
     * Get all fresh filters (via ajax)
     */
    this.onFilterClick();

    // set the paged
    $paged = $btnLoadMore.data('paged');

    // Update the selected filters in the div
    this.updateSelectedFilters();

    // Change filters selected text
    this.formatSpanText();


    var checkedItems = document.querySelectorAll('.filter_term');


  }

  /**
   * on click of checkbox
   *
   * @param e
   */
  onFilterClick(e) {

    // stop if on ajax
    if (isCallingAjax) {
      e.preventDefault();
      return;
    }

    // Reset the pagination
    $paged = 1;

    /**
     * Get the current filters
     */
    this.getFilters();

    /**
     * Update the list of selected filters in the textbox
     */
    this.updateSelectedFilters();

    /**
     * Change filtes selected text
     */
    this.formatSpanText();

    /**
     * ajax call
     */
    this.ajaxCall()

    /**
     * update browser
     */
    this.updateBrowser();

  }



  /**
   * on click of Load more
   *
   * @param e
   */
  onLoadClick(e) {
    e.preventDefault();

    if (isCallingAjax) return;
    if ($lastPage) return;

    $paged++;

    /**
     * Get the current filters
     */
    this.getFilters();

    /**
     * ajax call
     */
    this.ajaxCall()

  }


  updateSelectedFilters() {

    // Assuming you have a div with class 'filters' to update
    let $filtersDiv = $('.selected-filters');

    let selectedFilters = [];


    // Collect the selected filters
    $('input:checked').each(function() {
      const filterTermSlug = $(this).val();
      const filterTaxonomy = $(this).attr('name');
      selectedFilters.push({ taxonomy: filterTaxonomy, term: filterTermSlug });

      // open the details element to show the selected filters to the user
      $(this).closest('details').attr('open', true);
    });

    // Clear previous filters in the div
    $filtersDiv.empty();

    // Add the selected filters to the div
    if (selectedFilters.length > 0) {
      let filtersList = selectedFilters.map(
        filter => `<span>${filter.term}</span>`
      );
      $filtersDiv.append(filtersList);
    }
  }

  formatSpanText() {
    // Hide the span with text "auto"
    $("span:contains('auto')").hide();

    // Define the specific terms to be transformed to uppercase
    const uppercaseTerms = ["vmbo-tl", "Vwo", "HAVO", "VMBO B"];

    // Format the span text
    $("span").each(function() {
      let text = $(this).text().trim(); // Trim leading and trailing spaces

      const isUppercase = uppercaseTerms.some(function(term) {
        // Perform case-insensitive and space-insensitive check
        return term.toLowerCase().replace(/\s/g, '') === text.toLowerCase().replace(/\s/g, '');
      });

      if (isUppercase) {
        // Uppercase with special handling for "vmbo-tl"
        if (text.toLowerCase() === "vmbo-tl") {
          text = "VMBO TL";
        } else {
          text = text.toUpperCase();
        }
      } else {
        // Convert to title case
        text = text.replace(/-/g, ' ').replace(/\b\w+/g, function(match) {
          return match.charAt(0).toUpperCase() + match.slice(1);
        });
      }

      $(this).text(text);
    });
  }


  /**
   * get all terms that are selected (has class 'filtering')
   * into a bucket
   */
  getFilters() {
    $hasFilter = false;
    $filters = {};

    // For all filter items, if disabled or zero, hide them
    $('label.disabled').each(function () {
      let count = $(this).children('span.count').html();
      self.makeHidden( $(this), count );
    });


    // Collect all checkbox filters per taxonomy
    $('input:checked').each(function () {
      $hasFilter = true;

      const filterTermSlug = $(this).val();
      const filterTaxonomy = $(this).attr('name');

      if (filterTaxonomy in $filters) {
        $filters[filterTaxonomy].push(filterTermSlug);
      } else {
        $filters[filterTaxonomy] = [filterTermSlug];
      }

    });

    // Collect all url filters per taxonomy
    // update: 9 apr 2024: why is this here? Disabled till further notice

    //const queryString = window.location.search;
    //const urlParams = new URLSearchParams(queryString);
    //const entries = urlParams.entries();
    //
    //for (const entry of entries) {
    //  $hasFilter = true;
    //
    //  let filterTaxonomy = entry[0];
    //  let filterTermSlug = entry[1];
    //  // remove if it has brackets []
    //  filterTaxonomy = filterTaxonomy.replace(/\[(\d+)?\]/, '');
    //
    //  // Collect all filters per taxonomy
    //  if (filterTaxonomy in $filters) {
    //    $filters[filterTaxonomy].push(filterTermSlug);
    //  } else {
    //    $filters[filterTaxonomy] = [filterTermSlug];
    //  }
    //}

    // Set sessionStorage for filters
    sessionStorage.setItem('groupFilter', JSON.stringify($filters));

    // Show reset button or not?
    $('.btn_clear_filters').toggle($hasFilter);

  }

  /**
   * init all filter terms
   */
  initFilters() {

    // update the counter of the filter with the latest state
    let $filterCount = JSON.parse(sessionStorage.getItem('filterCount')) || {};

    Object.entries($filterCount).forEach((filter) => {

      const [term, count] = filter;
      const filterLabel = $('[data-slug="' + term + '"]');

      filterLabel.children('.count').html(count);
      //
      self.makeHidden( filterLabel, count );

    });

  }

  /**
   * make filter item hidden or not
   *
   * @param element
   * @param count
   */
  makeHidden( element, count ){

    // Hide the term if count is ZERO
    const $inputElement = element.children('input');

    // Hide all elements that have ZERO as count
    if (!$inputElement.is(':checked')) {
      element.parent('li').toggleClass("hide", count <= 0);
    }

    // To be sure, we update 'old and stored' html,
    // and remove the disabled classes
    element.removeClass("input-control--disabled");
    element.removeClass("disabled");
    $inputElement.attr("disabled", null);

  }
  /**
   * Ajax to the backend
   */
  ajaxCall() {
    if (isCallingAjax) return;

    // Show visual the AJAX call
    isCallingAjax = true;
    $btnLoadMore.html('Ophalen...');
    $search_overlay.fadeIn();

    const postArguments = {
      action: 'get_shop_results',
      nonce: ajax_nonce,
      filters: $filters,
      page: $paged
    };

    return $.ajax({
      url: ajax_link,
      method: 'post',
      data: postArguments,
      success: resp => this.handleSubmitExtResponse(resp),
    });
  }

  /**
   * Display the results from the backend
   *
   * @param response
   */
  handleSubmitExtResponse(response) {
    isCallingAjax = false;
    $btnLoadMore.html('Laad meer');

    // remove the overlay to show the results
    $search_overlay.fadeOut();

    if (response.errors) {
      console.log(response.errors)
    } else {
      const r = JSON.parse(response);

      // Get some current query information
      const info = JSON.parse(r.info);
      $total_products = info['total'];
      $total_pages = info['max_num_pages'];

      // if ZERO products returned, show a friendly message
      $('.no-products-card').toggleClass('hide', ! $total_products < 1);

      // Inject the returned HTML product-cards
      if ($paged === 1) {
        $productsLocation.html(r.products)
      } else {
        $productsLocation.append(r.products)
      }

      // save the updated html for later use
      sessionStorage.setItem('productHtml', $productsLocation.html());

      // remove load more if we are on last page
      if ($paged >= info['max_num_pages']) {
        $lastPage = true;
        $btnLoadMore.hide();
      } else {
        $lastPage = false;
        $btnLoadMore.show();
      }
      sessionStorage.setItem('$lastPage', $lastPage);

      // Parse and update the filters
      if (r.filters) {
        let $itemBucket = {};

        let _filter_groups = JSON.parse(r.filters);

        // Per group...
        Object.entries(_filter_groups).forEach((group) => {
          const [taxonomy, tax_details] = group;

          // extract the terms from the object
          let _filter_terms = tax_details.terms;

          // Receive the terms and update the storage element
          Object.entries(_filter_terms).forEach((term) => {
            const [key, value] = term;
            $itemBucket[value['slug']] = value['count'];
          });
        });

        // Save the filter count for later use
        sessionStorage.setItem('filterCount', JSON.stringify($itemBucket));

        // Update the DOM
        this.initFilters();

        // Call formatSpanText() after filters are updated
        this.formatSpanText();

      }
    }
  }

  /**
   * Onclick update the browser url with selected filters
   *
   */
  updateBrowser(){

    let selectedValue = "";
    $.each($filters, function(type, values) {
      $.each(values, function(index, value) {
        selectedValue = selectedValue + '&' + type + '[]=' + value;
      });
    });
    const newUrl = window.location.pathname + '?' + selectedValue.replace(/^&+|&+$/g, '');

    // Update the URL in the browser without reloading the page
    window.history.pushState({path:newUrl}, '', newUrl);
  }

  /**
   * clear filters
   */
  clearFilters() {
    sessionStorage.removeItem('$lastPage');
    sessionStorage.removeItem('productHtml');
    sessionStorage.removeItem('groupFilter');
    sessionStorage.removeItem('filterCount');
  }

  /**
   * Helper to check if given element is in the viewport
   *
   * @param elem
   * @returns {boolean}
   */
  isInViewport = function (elem) {
    if (!elem) return false;

    let bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
}
